var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconArrowLeftCurved = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 5,
    viewBox: "0 0 11 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 1.00073C3.925 1.00073 2.725 1.49573 1.8 2.30073L0 0.500732V5.00073H4.5L2.69 3.19073C3.385 2.61073 4.27 2.25073 5.25 2.25073C7.02 2.25073 8.525 3.40573 9.05 5.00073L10.235 4.61073C9.54 2.51573 7.575 1.00073 5.25 1.00073Z",
    fill: "#E5E4EC"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconArrowLeftCurved);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-arrow-left-curved.d802a4703457cba947e4c74804235182.svg";